import axios from "axios";
import {
	ACCESS_TOKEN,
	CHANGE_SELLER_ACTIVE_STATUS_URL,
	CHANGE_SELLER_VERIFICATION_STATUS_URL,
	CHANGE_SUBSCRIPTION_PLAN,
	CREATE_SELLER_PHONE_URL,
	CREATE_SELLER_PICKUP_ADDRESS_URL,
	CREATE_SELLER_PROFILE_URL,
	DELETE_SELLER_PHONE_URL,
	DELETE_SELLER_PICKUP_ADDRESS_URL,
	GET_SELLER_ACCOUNTS,
	GET_SELLER_LIST,
	UPDATE_SELLER_PHONE_URL,
	UPDATE_SELLER_PICKUP_ADDRESS_URL,
	UPDATE_SELLER_PROFILE_BY_ADMIN_URL,
	UPDATE_SELLER_PROFILE_URL,
	VERIFY_SELLER_URL,
} from "../helpers/Constant";

export default class SellerService {
	static getSellersList(params) {
		return axios.get(GET_SELLER_LIST, {
			...SellerService.getAuthHeader(),
			params,
		});
	}

	static createSellerProfile(data) {
		return axios.post(
			CREATE_SELLER_PROFILE_URL,
			data,
			SellerService.getAuthHeader(),
		);
	}

	static updateSellerProfile(data) {
		return axios.put(
			UPDATE_SELLER_PROFILE_URL,
			data,
			SellerService.getAuthHeader(),
		);
	}

	static updateSellerProfileByAdmin(id, data) {
		return axios.put(
			`${UPDATE_SELLER_PROFILE_BY_ADMIN_URL}/${id}`,
			data,
			SellerService.getAuthHeader(),
		);
	}

	static verifySeller(id, body) {
		return axios.put(
			`${VERIFY_SELLER_URL}/${id}`,
			body,
			SellerService.getAuthHeader(),
		);
	}

	static changeSellerVerifiedStatus(id, verified) {
		return axios.put(
			`${CHANGE_SELLER_VERIFICATION_STATUS_URL}/${id}`,
			null,
			{
				...SellerService.getAuthHeader(),
				params: { verified },
			},
		);
	}

	static changeSellerActiveStatus(id, active) {
		return axios.put(`${CHANGE_SELLER_ACTIVE_STATUS_URL}/${id}`, null, {
			...SellerService.getAuthHeader(),
			params: { active },
		});
	}

	static getSellerAccount(id) {
		return axios.get(
			`${GET_SELLER_ACCOUNTS}/${id}`,
			SellerService.getAuthHeader(),
		);
	}

	static changeSubscriptionPlan(id, body) {
		return axios.put(
			`${CHANGE_SUBSCRIPTION_PLAN}/${id}`,
			body,
			SellerService.getAuthHeader(),
		);
	}

	static createSellerPhone(data, id = null) {
		return axios.post(
			id ? `${CREATE_SELLER_PHONE_URL}/${id}` : CREATE_SELLER_PHONE_URL,
			data,
			SellerService.getAuthHeader(),
		);
	}

	static updateSellerPhone(id, data) {
		return axios.put(
			`${UPDATE_SELLER_PHONE_URL}/${id}`,
			data,
			SellerService.getAuthHeader(),
		);
	}

	static deleteSellerPhone(id) {
		return axios.delete(
			`${DELETE_SELLER_PHONE_URL}/${id}`,
			SellerService.getAuthHeader(),
		);
	}

	static createPickupAddress(data, id = null) {
		return axios.post(
			id
				? `${CREATE_SELLER_PICKUP_ADDRESS_URL}/${id}`
				: CREATE_SELLER_PICKUP_ADDRESS_URL,
			data,
			SellerService.getAuthHeader(),
		);
	}

	static updatePickupAddress(id, data) {
		return axios.put(
			`${UPDATE_SELLER_PICKUP_ADDRESS_URL}/${id}`,
			data,
			SellerService.getAuthHeader(),
		);
	}

	static deletePickupAddress(id) {
		return axios.delete(
			`${DELETE_SELLER_PICKUP_ADDRESS_URL}/${id}`,
			SellerService.getAuthHeader(),
		);
	}

	static getAuthHeader = () => {
		const accessToken = localStorage.getItem(ACCESS_TOKEN);
		return { headers: { "x-auth-token": `${accessToken}` } };
	};
}
